import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Pagination,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: "10px",
  borderRadius: "8px",
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  background: "linear-gradient(90deg, #00BB9F 0%, #6CD8BF 100%)",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  color: "#FFFFFF", // Set text color to white for header cells
}));

const BodyTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
}));

const ProductTable = ({ title, rows = [], className }) => {
  const itemsPerPage = 5; // Number of items per page
  const [currentPage, setCurrentPage] = React.useState(1); // Current page state

  // Calculate the rows to display based on the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const rowsToDisplay = rows.slice(startIndex, endIndex);

  // Handle page change
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };
  console.log("className", rows[0]);
  // State for modal open
  return (
    <>
      {rows.length > 0 ? (
        <>
          <div className={className}>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            <StyledTableContainer component={Paper}>
              <Table>
                <StyledTableHead>
                  <TableRow>
                    {Object.keys(rows[0]).map((key) => (
                      <StyledTableCell key={key}>{key}</StyledTableCell>
                    ))}
                  </TableRow>
                </StyledTableHead>
                <TableBody>
                  {rowsToDisplay.map((row, index) => (
                    <TableRow key={index}>
                      {Object.values(row).map((value, idx) => (
                        <BodyTableCell key={idx}>{value}</BodyTableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          </div>
          {/* Pagination */}
          <div>
            <Pagination
              count={Math.ceil(rows.length / itemsPerPage)} // Total pages
              page={currentPage} // Current page
              onChange={handlePageChange} // Page change handler
              color="primary" // Optional: Styling
              style={{
                marginTop: "16px",
                display: "flex",
                justifyContent: "flex-end",
              }} // Optional: Styling
              sx={{
                "& .MuiButtonBase-root": {
                  borderRadius: "50%",
                  cursor: "pointer",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundImage: "linear-gradient(90deg, #00BB9F, #B0EE93)", // Changed backgroundColor to backgroundImage for linear gradient
                  color: "#ffffff",
                },
              }}
            />
          </div>
        </>
      ) : (
        <>
          <div className={className}>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            <StyledTableContainer component={Paper}>
              <Table>
                <StyledTableHead>
                  <TableRow>
                    <StyledTableCell>รายการ</StyledTableCell>
                  </TableRow>
                </StyledTableHead>
                <TableBody>
                  <TableRow>
                    <BodyTableCell>ไม่มึข้อมูล</BodyTableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </StyledTableContainer>
          </div>
        </>
      )}
    </>
  );
};

export default ProductTable;
